<template>
<main class="group__main">
    <div class="group__main__content">
        <router-view />
    </div>
</main>
</template>